module.exports = __webpack_public_path__ + "img/绿-选中@3x.20a5b319.png";